import { Link } from "gatsby"
import PropTypes from "prop-types"
import React from "react"

const Header = ({ siteTitle }) => (
  <header className="flex items-center justify-between px-6 py-6">
    <div class="flex">
      <div class="sm:-my-px sm:ml-6 sm:flex">
        <a
          href="/"
          class="inline-flex items-center px-1 pt-1 border-b-2 hover:border-teal-500 border-transparent text-sm font-medium leading-5 text-indigo-100 focus:outline-none focus:border-teal-700 transition duration-150 ease-in-out"
        >
          Work
        </a>
      </div>
    </div>
    <div class="sm:-my-px sm:ml-6 sm:flex items-center">
      <a
        href="https://www.linkedin.com/in/tylernixon/"
        target="_blank"
        class="inline-flex items-center px-1 pt-1 focus:outline-none text-indigo-100 hover:text-teal-400 transition duration-150 ease-in-out"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="26"
          height="26"
          viewBox="0 0 26 26"
          className="fill-current"
        >
          <path d="M21.125 0H4.875A4.876 4.876 0 000 4.875v16.25A4.876 4.876 0 004.875 26h16.25A4.876 4.876 0 0026 21.125V4.875A4.876 4.876 0 0021.125 0zM8.039 22.07H4L3.977 9.977h4.039zM5.918 8.395h-.023c-1.32 0-2.172-.91-2.172-2.043 0-1.16.879-2.04 2.222-2.04 1.344 0 2.168.88 2.196 2.04 0 1.132-.856 2.043-2.223 2.043zM22.043 22.07h-4.074V15.5c0-1.59-.422-2.672-1.844-2.672-1.086 0-1.672.73-1.953 1.438-.106.254-.133.601-.133.957v6.847H9.945L9.922 9.977h4.094l.023 1.707c.524-.809 1.395-1.954 3.48-1.954 2.586 0 4.52 1.688 4.52 5.317v7.023z"></path>
        </svg>
      </a>
      <a
        href="https://github.com/Gypson"
        target="_blank"
        class="inline-flex items-center px-1 pt-1 focus:outline-none text-indigo-100 hover:text-teal-400 transition duration-150 ease-in-out"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="32"
          height="32"
          viewBox="0 0 32 32"
          className="fill-current"
        >
          <path d="M16 4C9.371 4 4 9.371 4 16c0 5.3 3.438 9.8 8.207 11.387.602.11.82-.258.82-.578 0-.286-.011-1.04-.015-2.04-3.34.723-4.043-1.609-4.043-1.609-.547-1.387-1.332-1.758-1.332-1.758-1.09-.742.082-.726.082-.726 1.203.086 1.836 1.234 1.836 1.234 1.07 1.836 2.808 1.305 3.492 1 .11-.777.422-1.305.762-1.605-2.664-.301-5.465-1.332-5.465-5.93 0-1.313.469-2.383 1.234-3.223-.121-.3-.535-1.523.117-3.175 0 0 1.008-.32 3.301 1.23A11.487 11.487 0 0116 9.805c1.02.004 2.047.136 3.004.402 2.293-1.55 3.297-1.23 3.297-1.23.656 1.652.246 2.875.12 3.175.77.84 1.231 1.91 1.231 3.223 0 4.61-2.804 5.621-5.476 5.922.43.367.812 1.101.812 2.219 0 1.605-.011 2.898-.011 3.293 0 .32.214.695.824.578C24.566 25.797 28 21.3 28 16c0-6.629-5.371-12-12-12z"></path>
        </svg>
      </a>
    </div>
  </header>
)

Header.propTypes = {
  siteTitle: PropTypes.string,
}

Header.defaultProps = {
  siteTitle: ``,
}

export default Header
